import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/layout/Layout";

// Auth
import Login from "./pages/Login";

// Dashboard
import Dashboard from "./pages/admin/Dashboard";

// CRM
import LeadsAdmin from "./pages/admin/LeadsAdmin";
import LeadProfile from "./pages/admin/LeadProfile";
import WaitlistAdmin from "./pages/admin/WaitlistAdmin";
import ContactsAdmin from "./pages/admin/ContactsAdmin";
import CampaignsAdmin from "./pages/admin/CampaignsAdmin";
import FollowupRulesAdmin from "./pages/admin/FollowupRulesAdmin";
import Flows from "./pages/Flows";
import FlowEditor from "./pages/FlowEditor";
import WhatsAppPage from "./pages/admin/WhatsAppPage";
import AppointmentsAdmin from "./pages/admin/AppointmentsAdmin";

// Conteúdo
import BlogAdmin from "./pages/admin/BlogAdmin";
import BlogEditor from "./pages/admin/BlogEditor";
import BrandVoiceAdmin from "./pages/admin/BrandVoiceAdmin";
import GalleryAdmin from "./pages/admin/GalleryAdmin";
import TestimonialsAdmin from "./pages/admin/TestimonialsAdmin";
import GeradorRoteiros from "./pages/GeradorRoteiros";

// Estoque & Financeiro
import StockDashboard from "./pages/admin/StockDashboard";
import StockProducts from "./pages/admin/StockProducts";
import StockProductDetail from "./pages/admin/StockProductDetail";
import StockEntry from "./pages/admin/StockEntry";
import StockMovements from "./pages/admin/StockMovements";
import FinanceAdmin from "./pages/admin/FinanceAdmin";

// Analytics
import AnalyticsAdmin from "./pages/admin/AnalyticsAdmin";
import Visitors from "./pages/Visitors";
import Heatmap from "./pages/Heatmap";
import Mentions from "./pages/Mentions";

// Módulos extras
import Academy from "./pages/admin/Academy";
import AcademyAdmin from "./pages/admin/AcademyAdmin";
import AcademyAula from "./pages/admin/AcademyAula";
import AcademyCurso from "./pages/admin/AcademyCurso";
import AcademyQuestionario from "./pages/admin/AcademyQuestionario";
import MetaCAPIConfig from "./pages/admin/MetaCAPIConfig";

// Config
import Templates from "./pages/Templates";
import TemplateEditor from "./pages/TemplateEditor";
import UsersAdmin from "./pages/admin/UsersAdmin";
import ApiKeysAdmin from "./pages/admin/ApiKeysAdmin";
import BackupsAdmin from "./pages/admin/BackupsAdmin";
import Settings from "./pages/Settings";
import TeamAdmin from "./pages/admin/TeamAdmin";
import AtendimentoPage from "./pages/admin/AtendimentoPage";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    <Route element={<Layout />}>
                        <Route path="/dashboard" element={<Dashboard />} />

                        {/* CRM */}
                        <Route path="/leads" element={<LeadsAdmin />} />
                        <Route path="/leads/:id" element={<LeadProfile />} />
                        <Route path="/waitlist" element={<WaitlistAdmin />} />
                        <Route path="/contacts" element={<ContactsAdmin />} />
                        <Route path="/campaigns" element={<CampaignsAdmin />} />
                        <Route path="/followup" element={<FollowupRulesAdmin />} />
                        <Route path="/flows" element={<Flows />} />
                        <Route path="/whatsapp" element={<WhatsAppPage />} />
                        <Route path="/eventos" element={<AppointmentsAdmin />} />

                        {/* Conteúdo */}
                        <Route path="/blog" element={<BlogAdmin />} />
                        <Route path="/brand-voice" element={<BrandVoiceAdmin />} />
                        <Route path="/galeria" element={<GalleryAdmin />} />
                        <Route path="/testemunhos" element={<TestimonialsAdmin />} />
                        <Route path="/roteiros" element={<GeradorRoteiros />} />

                        {/* Estoque */}
                        <Route path="/estoque" element={<StockDashboard />} />
                        <Route path="/estoque/produtos" element={<StockProducts />} />
                        <Route path="/estoque/produtos/:id" element={<StockProductDetail />} />
                        <Route path="/estoque/entrada" element={<StockEntry />} />
                        <Route path="/estoque/movimentacoes" element={<StockMovements />} />

                        {/* Financeiro */}
                        <Route path="/financeiro" element={<FinanceAdmin />} />

                        {/* Analytics */}
                        <Route path="/analytics" element={<AnalyticsAdmin />} />
                        <Route path="/visitors" element={<Visitors />} />
                        <Route path="/heatmap" element={<Heatmap />} />
                        <Route path="/mencoes" element={<Mentions />} />

                        {/* Academy */}
                        <Route path="/academy" element={<Academy />} />
                        <Route path="/academy/admin" element={<AcademyAdmin />} />
                        <Route path="/academy/curso/:cursoId" element={<AcademyCurso />} />

                        {/* Equipe */}
                        <Route path="/equipe" element={<TeamAdmin />} />
                        <Route path="/atendimento/:id" element={<AtendimentoPage />} />

                        {/* Config */}
                        <Route path="/templates" element={<Templates />} />
                        <Route path="/templates/new" element={<TemplateEditor />} />
                        <Route path="/templates/:id" element={<TemplateEditor />} />
                        <Route path="/usuarios" element={<UsersAdmin />} />
                        <Route path="/api-keys" element={<ApiKeysAdmin />} />
                        <Route path="/backups" element={<BackupsAdmin />} />
                        <Route path="/meta-capi" element={<MetaCAPIConfig />} />
                        <Route path="/settings" element={<Settings />} />
                    </Route>

                    {/* Full screen — sem sidebar */}
                    <Route path="/flows/:flowId" element={<FlowEditor />} />
                    <Route path="/blog/editor" element={<BlogEditor />} />
                    <Route path="/blog/editor/:postId" element={<BlogEditor />} />
                    <Route path="/academy/aula/:aulaId" element={<AcademyAula />} />
                    <Route path="/academy/questionario/:questionarioId" element={<AcademyQuestionario />} />

                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </AuthProvider>
    );
}

export default App;
